import privacy from '@/content/legal/privacy-policy.md?raw';
import { Container, useTheme } from '@mui/material';

import { LegalMarkdown } from '@/components/Marketing/LegalMarkdown';
import { usePageMeta } from '@/hooks/usePageMeta';

export { BodyText } from './BodyText';

export const PrivacyPolicy = () => {
  const theme = useTheme();
  usePageMeta(
    'Privacy Policy',
    'How Unbeatable Loans collects, uses, and shares information when you use our services.'
  );
  return (
    <Container sx={{ py: 5, color: theme.palette.text.primary }}>
      <LegalMarkdown content={privacy} />
    </Container>
  );
};
